import { render, staticRenderFns } from "./praticeType.vue?vue&type=template&id=f96c34cc&scoped=true&"
import script from "./praticeType.vue?vue&type=script&lang=js&"
export * from "./praticeType.vue?vue&type=script&lang=js&"
import style0 from "./praticeType.vue?vue&type=style&index=0&id=f96c34cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f96c34cc",
  null
  
)

export default component.exports